import Joi from 'joi';
import { create } from 'zustand';

export type TRawConfig = {
  apiUri: string;
  origins: string;
};

const RawConfigSchema = Joi.object({
  apiUri: Joi.string().required(),
  origins: Joi.string().required(),
});

export type TConfig = {
  apiUri: string;
  origins: string[];
};

const defaultConfig: TConfig = {
  apiUri: 'http://localhost:4040',
  origins: [],
};

export const useConfig = create<{
  config: TConfig;
}>(() => ({
  config: defaultConfig,
}));

export function initConfig(config: TRawConfig | null) {
  console.log('==> initConfig');
  if (!config) {
    throw Error('No config file');
  }

  const validationResults = RawConfigSchema.validate(config);
  if (validationResults.error) {
    console.log('Config error', validationResults.error.details);
    throw new Error(`Config file is NOT VALID! Details: ${validationResults.error.message}`);
  }

  useConfig.setState({
    config: {
      apiUri: validationResults.value.apiUri,
      origins: validationResults.value.origins.split(','),
    },
  });
}
